import React, { useState, useEffect } from 'react';
import './style.css';
import Logo from '../../assets/LOGOTIPO.png';
import User from '../../assets/User.png';
import Config from '../../assets/config.png';
import { NavLink } from "react-router-dom";
import { useAppContext } from '../../pages/context/AppContext.jsx';
import { usePermissoes } from "../../componente/permissoes.js";
import { useNavigate } from "react-router-dom";

const Sidebar = ({ onClick }) => {
    const [activeMenu, setActiveMenu] = useState(null);
    const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth > 768);
    const { listaempresa, codempresa, setCodEmpresa, licenca, usuario, limparContexto } = useAppContext();

    const { podeAcessar } = usePermissoes();

    const navigate = useNavigate();

    const handleLogout = () => {
        // limpa contexto
        limparContexto();

        // redireciona
        navigate("/");
    };

    const toggleMenu = (menu) => {
        setActiveMenu(activeMenu === menu ? null : menu);
    };

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    const handleCompanyChange = (event) => {
        setCodEmpresa(event.target.value); // Armazena "null" para todas as empresas
    };

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 768) {
                setSidebarOpen(false);
            } else {
                setSidebarOpen(true);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div >
            <div className="hamburger" onClick={toggleSidebar}>
                <i className="fa-solid fa-bars"></i> {/* Ícone de hambúrguer */}
            </div>
            <div className={`d-flex flex-column justify-content-between menu-container sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
                <div>
                    <div className="logo-details">
                        <img className="Logo" src={Logo} alt="logo" />
                        <span className="logo-name">Olá {usuario}</span>
                    </div>

                    <div className="menu-item" onClick={() => toggleMenu('menu0')}>
                        <NavLink to="/principal" className="dropdown-item">
                            Dashboard
                        </NavLink>
                    </div>

                    <div className="menu-item" onClick={() => toggleMenu('menu1')}>
                        <div className='menu-item-texto'>Cadastros
                            <i className={`bx ${activeMenu === 'menu1' ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'}`}></i>
                        </div>

                        <div className={`submenu ${activeMenu === 'menu1' ? 'active' : ''}`}>
                            <div hidden={!podeAcessar("/cad/empresa")} className="submenu-item" onClick={() => toggleMenu('menu11')}>
                                <NavLink to="/cad/empresa" className="dropdown-item">
                                    Empresa
                                </NavLink>
                            </div>

                            <div hidden={!podeAcessar("/cad/usuario")} className="submenu-item" onClick={() => toggleMenu('menu12')}>
                                <NavLink to="/cad/usuario" className="dropdown-item">
                                    Usuário
                                </NavLink>
                            </div>

                            <div hidden={!podeAcessar("/cad/funcionario")} className="submenu-item" onClick={() => toggleMenu('menu13')}>
                                <NavLink to="/cad/funcionario" className="dropdown-item">
                                    Funcionário
                                </NavLink>
                            </div>

                            <div hidden={!podeAcessar("/cad/fornecedor")} className="submenu-item" onClick={() => toggleMenu('menu14')}>
                                <NavLink to="/cad/fornecedor" className="dropdown-item">
                                    Fornecedor
                                </NavLink>
                            </div>

                            <div hidden={!podeAcessar("/cad/cliente")} className="submenu-item" onClick={() => toggleMenu('menu15')}>
                                <NavLink to="/cad/cliente" className="dropdown-item">
                                    Cliente
                                </NavLink>
                            </div>

                            <div hidden={!podeAcessar("/cad/produto")} className="submenu-item" onClick={() => toggleMenu('menu16')}>
                                <NavLink to="/cad/produto" className="dropdown-item">
                                    Produto
                                </NavLink>
                            </div>

                            <div hidden={!podeAcessar("/cad/caixa")} className="submenu-item" onClick={() => toggleMenu('menu17')}>
                                <NavLink to="/cad/caixa" className="dropdown-item">
                                    Caixa
                                </NavLink>
                            </div>

                            <div hidden={!podeAcessar("/cad/moeda")} className="submenu-item" onClick={() => toggleMenu('menu18')}>
                                <NavLink to="/cad/moeda" className="dropdown-item">
                                    Moeda
                                </NavLink>
                            </div>

                            <div hidden={!podeAcessar("/cad/categoria")} className="submenu-item" onClick={() => toggleMenu('menu19')}>
                                <NavLink to="/cad/categoria" className="dropdown-item">
                                    Categoria
                                </NavLink>
                            </div>
                        </div>
                    </div>

                    <div className="menu-item" onClick={() => toggleMenu('menu2')}>
                        <div className='menu-item-texto'>Operações
                            <i className={`bx ${activeMenu === 'menu2' ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'}`}></i>
                        </div>

                        <div className={`submenu ${activeMenu === 'menu2' ? 'active' : ''}`}>
                            <div hidden={!podeAcessar("/ope/pedido")} className="submenu-item" onClick={() => toggleMenu('menu21')}>
                                <NavLink to="/ope/pedido" className="dropdown-item">
                                    Emissão de Pedido
                                </NavLink>
                            </div>

                            <div hidden={!podeAcessar("/ope/orcamento")} className="submenu-item" onClick={() => toggleMenu('menu22')}>
                                <NavLink to="/ope/orcamento" className="dropdown-item">
                                    Emissão de Orçamento
                                </NavLink>
                            </div>

                            <div hidden={!podeAcessar("/ope/contaspagar")} className="submenu-item" onClick={() => toggleMenu('menu23')}>
                                <NavLink to="/ope/contaspagar" className="dropdown-item">
                                    Contas a Pagar
                                </NavLink>
                            </div>

                            <div hidden={!podeAcessar("/ope/contasreceber")} className="submenu-item" onClick={() => toggleMenu('menu24')}>
                                <NavLink to="/ope/contasreceber" className="dropdown-item">
                                    Contas a Receber
                                </NavLink>
                            </div>

                            <div hidden={!podeAcessar("/ope/relacaonota")} className="submenu-item" onClick={() => toggleMenu('menu25')}>
                                <NavLink to="/ope/relacaonota" className="dropdown-item">
                                    Relação de NFe
                                </NavLink>
                            </div>

                            <div hidden={!podeAcessar("/ope/entradaprodutos")} className="submenu-item" onClick={() => toggleMenu('menu26')}>
                                <NavLink to="/ope/entradaprodutos" className="dropdown-item">
                                    Entrada de Produtos
                                </NavLink>
                            </div>
                        </div>
                    </div>

                    <div className="menu-item" onClick={() => toggleMenu('menu3')}>
                        <div className='menu-item-texto'>Relatórios
                            <i className={`bx ${activeMenu === 'menu3' ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'}`}></i>
                        </div>

                        <div className={`submenu ${activeMenu === 'menu3' ? 'active' : ''}`}>
                            <div hidden={!podeAcessar("/rel/estoqueporempresa")} className="submenu-item" onClick={() => toggleMenu('menu31')}>
                                <NavLink to="/rel/estoqueporempresa" className="dropdown-item">
                                    Estoque Por Empresa
                                </NavLink>
                            </div>

                            <div hidden={!podeAcessar("/rel/relpedido")} className="submenu-item" onClick={() => toggleMenu('menu32')}>
                                <NavLink to="/rel/relpedido" className="dropdown-item">
                                    Pedidos
                                </NavLink>
                            </div>

                            <div hidden={!podeAcessar("/rel/relrecebimentopormoeda")} className="submenu-item" onClick={() => toggleMenu('menu33')}>
                                <NavLink to="/rel/relrecebimentopormoeda" className="dropdown-item">
                                    Recebimento Por Moeda
                                </NavLink>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Adicione mais menus conforme necessário */}

                <div className="profile-details">
                    <div className="profile-content">
                        <img className='img-profile' src={User} alt="User" />
                    </div>
                    <div className="name-job">
                        <div className="profile-name">
                            {/* Contêiner para o select */}
                            <div className="select-container">
                                <select className="form-select sidebar-select" value={codempresa || '0'} onChange={handleCompanyChange}>
                                    <option value="0">Todas as empresas</option>
                                    {listaempresa.map((company, index) => (
                                        <option key={index} value={company.codempresa}>{company.nomefantasia}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-6 licenca-versao'>
                                <div className="job mt-1">
                                    {licenca ? <label className='bg-success'>Licenciado</label> : <label className='bg-danger'>Expirado...</label>}
                                </div>
                                <div className="job">0.0.0.54</div>
                            </div>
                            <div className='col-6 d-flex justify-content-center align-items-center gap-2'>

                                {/* Botão Configurações */}
                                <img
                                    className='img-config'
                                    onClick={() => { onClick() }}
                                    src={Config}
                                    alt="Configurações"
                                    title="Configurações"
                                />

                                {/* Botão Logout */}
                                <i
                                    className="img-config fa-solid fa-right-from-bracket logout-icon"
                                    title="Sair"
                                    onClick={handleLogout}
                                />

                            </div>

                        </div>
                    </div>

                    <i className="bx bx-log-out"></i>
                </div>
            </div>

        </div>
    );
};

export default Sidebar;
